import apiClient from "./apiClient";

const BASE = "/api/Bank";

// API returns bankID (no `id`) — alias it so list/edit/select code using `.id` works.
const withId = (b) => ({ ...b, id: b.bankID });

export const getBanks = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const createBank = (data) =>
  apiClient.post(`${BASE}/save`, { bankName: data.bankName, openingBalance: Number(data.openingBalance) || 0 });
export const updateBank = (id, data) =>
  apiClient.post(`${BASE}/save`, { bankName: data.bankName, openingBalance: Number(data.openingBalance) || 0, bankID: id });
export const deleteBank = (id) => apiClient.delete(`${BASE}/${id}`);
